import moment from 'moment'
import { validatePolish } from 'validate-polish'

const normalizePesel = pesel => `${pesel || ''}`.replace(/\D/g, '')

const resolvePeselBirthDate = pesel => {
  const normalizedPesel = normalizePesel(pesel)
  if (!validatePolish.pesel(normalizedPesel)) {
    return null
  }

  const yearPart = parseInt(normalizedPesel.slice(0, 2), 10)
  const encodedMonth = parseInt(normalizedPesel.slice(2, 4), 10)
  const day = parseInt(normalizedPesel.slice(4, 6), 10)

  let century = 1900
  let month = encodedMonth

  if (encodedMonth >= 81 && encodedMonth <= 92) {
    century = 1800
    month -= 80
  } else if (encodedMonth >= 61 && encodedMonth <= 72) {
    century = 2200
    month -= 60
  } else if (encodedMonth >= 41 && encodedMonth <= 52) {
    century = 2100
    month -= 40
  } else if (encodedMonth >= 21 && encodedMonth <= 32) {
    century = 2000
    month -= 20
  } else if (encodedMonth >= 1 && encodedMonth <= 12) {
    century = 1900
  } else {
    return null
  }

  const birthDate = moment({
    year: century + yearPart,
    month: month - 1,
    day,
  })

  return birthDate.isValid() ? birthDate : null
}

const resolvePatientSexFromPesel = pesel => {
  const normalizedPesel = normalizePesel(pesel)
  if (!validatePolish.pesel(normalizedPesel)) {
    return null
  }

  return parseInt(normalizedPesel.charAt(9), 10) % 2 === 0 ? 'F' : 'M'
}

const resolvePatientAgeFromPesel = (pesel, referenceDate = null) => {
  const birthDate = resolvePeselBirthDate(pesel)
  if (!birthDate) {
    return null
  }

  const effectiveReferenceDate = referenceDate ? moment(referenceDate) : moment()
  if (!effectiveReferenceDate.isValid()) {
    return null
  }

  return effectiveReferenceDate.diff(birthDate, 'years')
}

const resolvePatientDemographicsFromPesel = (pesel, referenceDate = null) => {
  const sex = resolvePatientSexFromPesel(pesel)
  const age = resolvePatientAgeFromPesel(pesel, referenceDate)

  if (!sex || age === null) {
    return null
  }

  return { sex, age }
}

export {
  normalizePesel,
  resolvePeselBirthDate,
  resolvePatientSexFromPesel,
  resolvePatientAgeFromPesel,
  resolvePatientDemographicsFromPesel,
}
